import { useParams } from "react-router-dom"
import { defaultDifficulties } from "~/lib/difficulty"
import { useOrganization } from "./useOrganization"

export function useDifficulties(teamId?: string | null) {
	const { teamSlug } = useParams<{ teamSlug: string }>()
	const { organization } = useOrganization()
	const team = organization?.teams.find((entry) =>
		teamId ? entry.id === teamId : entry.slug === teamSlug
	)
	return team?.difficulties ?? defaultDifficulties
}
